import { useTranslation } from '@pulsex/localization'
import { Currency, TradeType } from '@pulsex/sdk'
import { Flex, GasIcon, useMatchBreakpoints } from '@pulsex/uikit'
import { LoadingOpacityContainer } from 'components/Loader/LoadingRows'
import { MouseoverTooltip } from 'components/Tooltip'
import { InterfaceTrade } from 'state/routing/types'
import styled from 'styled-components'

const GasWrapper = styled(Flex)`
  align-items: center;
  color: ${({ theme }) => theme.colors.textSubtle};
  user-select: none;
`
const StyledGasIcon = styled(GasIcon)`
  margin-right: 4px;
  height: 18px;
  & > * {
    stroke: ${({ theme }) => theme.colors.tertiary};
  }
`
export const TooltipContainer = styled.div`
  max-width: 256px;
  cursor: default;
  padding: 0.6rem 1rem;

  color: ${({ theme }) => theme.colors.tertiary};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  word-break: break-word;

  background: ${({ theme }) => theme.colors.backgroundAlt2};
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
`
export const ResponsiveTooltipContainer = styled(TooltipContainer)<{ origin?: string; width?: string }>`
  background-color: ${({ theme }) => theme.colors.backgroundAlt2};
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  padding: 1rem;
  width: ${({ width }) => width ?? 'auto'};

  ${({ theme }) => theme.mediaQueries.xs} {
    transform: scale(0.8);
    transform-origin: top right;
  }
`

export default function GasEstimateBadge({
  trade,
  loading,
}: {
  trade: InterfaceTrade<Currency, Currency, TradeType> | undefined | null // dollar amount in active chain's stablecoin
  loading: boolean
  showRoute?: boolean // show route instead of gas estimation summary
  disableHover?: boolean
}) {
  const { t } = useTranslation()
  const { isMobile } = useMatchBreakpoints()
  const formattedGasPriceString = trade?.gasUseEstimateUSD
    ? trade.gasUseEstimateUSD.toFixed(2) === '0.00'
      ? '<$0.01'
      : `$${  trade.gasUseEstimateUSD.toFixed(2)}`
    : undefined

  return (
    <MouseoverTooltip 
      isMobile={isMobile}
      text={
        t(`Estimated network fee $${trade?.gasUseEstimateUSD?.toFixed(2)} Estimate may differ due to your wallet gas settings`)
      }
    >
      <LoadingOpacityContainer $loading={loading}>
        <GasWrapper>
          <StyledGasIcon />
          {formattedGasPriceString ?? null}
        </GasWrapper>
      </LoadingOpacityContainer>
    </MouseoverTooltip>
  )
}
